import React, {createContext, useReducer, useContext, useEffect} from 'react';
import {useLocation} from "react-router-dom";

const STORAGE_KEY = 'supportMetadata';
const STORAGE_KEY_PREV = 'prevSupportMetadata';

const initialState = {
    module: "",
    step: "",
    transactionData: {},
};

function supportContextReducer(state, action) {
    switch (action.type) {
        case 'MODULE_LOAD':
            return {
                module: action.payload?.module,
                step: action.payload?.step,
                transactionData: {},
            };
        case 'CHANGE_STEP':
            return {
                ...state,
                step: action.payload,
            };
        case 'UPDATE_TRANSACTION':
            return {
                ...state,
                transactionData: {...state.transactionData, ...action.payload},
            };
        case 'RESET_FLOW':
            return initialState;
        default:
            return state;
    }
}

const SupportContext = createContext();

export const SupportContextProvider = ({children}) => {
    let location = useLocation();
    // Load from localStorage
    const getInitialState = () => {
        const stored = localStorage.getItem(STORAGE_KEY);
        // If current page is help do not impact current transaction in store
        if (location.pathname.toLowerCase().includes('help')) {
            return JSON.parse(stored)
        }
        else {
            try {
                if (stored) {
                    // save prev info to prev key, reset current
                    localStorage.setItem(STORAGE_KEY_PREV, stored);
                    localStorage.setItem(STORAGE_KEY, JSON.stringify(initialState));
                }
                return initialState;
            } catch (err) {
                console.error('Failed to load user flow state:', err);
                return initialState;
            }
        }
    };

    const [state, dispatch] = useReducer(supportContextReducer, initialState, getInitialState);

    // Save to localStorage on state change
    useEffect(() => {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
        } catch (err) {
            console.error('Failed to save user flow state:', err);
        }
    }, [state]);

    return (
        <SupportContext.Provider value={{state, dispatch}}>
            {children}
        </SupportContext.Provider>
    );
};

export const useSupportContext = () => useContext(SupportContext);
